<template>
  <!--数据分析-城镇奖扶人数汇总表 HYT  -->
  <div>
    <div class="searchcontent">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-select size="small" style="width:250px" v-model="searchForm.year" placeholder="请选择年份">
            <el-option v-for="item in searchForm.arrYear" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" @click="onback">返回</el-button>
        </el-form-item>
        <el-form-item>
          <span style="color:red">此表非实时统计，当天查询的是前一天截至到24时的数据。</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="searchtable">
      <el-descriptions :model="topcontent" :column="1" :size="size" border class="tablename">
        <el-descriptions-item>
          {{topcontent.year}}城镇独生子女父母奖励扶助对象人数汇总表
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2" :size="size" border class="tablecity">
        <el-descriptions-item>
          所属地区：{{topcontent.regionName}}
        </el-descriptions-item>
        <el-descriptions-item>
          单位：人
        </el-descriptions-item>

      </el-descriptions>
      <el-table ref="table" :data="rewardinfolist" border stripe v-loading="showDataLoading" :header-row-style="{height:'30px'}" :header-cell-style="{padding:'5px'}" :row-style="{height:'30px'}" :cell-style="{padding:'5px'}">
        <el-table-column prop="regionName" label="地区" width="200">
          <template slot-scope="scope">
            <span @click="getDetail(scope.row)" v-if="scope.row.regionLevel <5">
              <el-link type="primary">{{scope.row.regionName}}</el-link>
            </span>
            <span v-else>{{scope.row.regionName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="本年扶助人数">
          <el-table-column prop="rewardEnjoyTotalNum" label="本年扶助人数" min-width="95">
          </el-table-column>
          <el-table-column prop="reportTotalNum" label="本年新增" min-width="95">
          </el-table-column>
          <el-table-column prop="rewardMoveinTotalNum" label="迁入新增" min-width="95">
          </el-table-column>
          <el-table-column prop="rewardExitTotalNum" label="本年退出" min-width="95">
          </el-table-column>
          <el-table-column prop="rewardMoveoutTotalNum" label="迁出退出" min-width="95">
          </el-table-column>
        </el-table-column>
        <el-table-column prop="lastRewardEnjoyTotalNum" label="上年扶助人数" min-width="95">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>

import router from '@/router.js'
import { baseconfig } from '@/config.js'
import { statisticstownrewardinfopeoplelistModel } from '@/request/reportformmanage.js'
import $ from 'jquery'
import { sysframe } from '@/tools/sysframe.js'
import store from '@/store'
import { CommonFormat } from '@/tools/common.js'
export default {
  data() {

    return {
      size: '',
      loading: false,
      rewardinfolist: [],
      showDataLoading: false,
      lsp: [],
      permission: {
        isHaveExcelPermission: false,

      },
      // 搜索
      searchForm: {
        year: CommonFormat.getCurrentApplyYear(), // 当前申报年份
        arrYear: CommonFormat.getFunYearData(), // 选择年份
        region_level: 0,
        region_id: 0,
        pregionid: 0,
        filter_level: 0
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      regionLevel: 1,
      provinceIDdisabled: false,
      cityIDdisabled: false,
      districtIDdisabled: false,
      cityindex: 1,
      region_level: 1,
      topcontent: {
        regionName: '',
        bregionName: '',
        year: CommonFormat.getCurrentApplyYear(),
      }
    }

  },
  created: async function () {
    this.searchForm.region_id = store.getters.adminRegionID
    this.searchForm.region_level = parseInt(store.getters.adminRegionLevel)
    console.log('***********', this.searchForm.region_level);
    await this.getrewardinfolist(this.searchForm.year, this.searchForm.region_level, this.searchForm.region_id, this.searchForm.filter_level, 1)
    $('.el-table').css('min-height', ($(".tab-content").height() - 30 - $(".searchcontent").outerHeight(true)) + 'px')
  },
  mounted: function () {

  },
  methods: {
    initLeft() {
      return sysframe.getSideBarLeft()
    },
    // 列表
    async getrewardinfolist(reward_year, region_level, region_id, filter_level, isfirst) {
      if (reward_year === '' || reward_year == null || reward_year == undefined) {
        reward_year = 0
      }

      this.showDataLoading = true
      await statisticstownrewardinfopeoplelistModel.statisticstownrewardinfopeoplelistModel(reward_year, region_level, region_id, filter_level).then(response => {
        this.showDataLoading = false
        this.rewardinfolist = []
        console.log(4444, response)
        switch (response.data.code) {
          case 100: {
            this.topcontent.bregionName = response.data.pregionname
            if (isfirst == 1) {
              this.topcontent.regionName = this.topcontent.bregionName
            }
            console.log(this.topcontent.regionName, response.data.pregionname)
            this.searchForm.pregionid = response.data.pregionid
            console.log(this.searchForm.pregionid, response.data.pregionid)
            this.rewardinfolist = response.data.result
            console.log(55555, this.rewardinfolist)
          }
            break;
          case 101:
            this.topcontent.bregionName = response.data.pregionname
            if (isfirst == 1) {
              this.topcontent.regionName = this.topcontent.bregionName
            }
            this.searchForm.pregionid = response.data.pregionid
            this.topcontent.bregionName = response.data.pregionname
            this.rewardinfolist = []
            break;
          case 100002:
            this.$message.error(baseconfig.no_permission_message);
            break;
          default:
            this.$message.error(response.data.message);
            break;
        }
      }).catch(error => { })
    },
    async onSearch() {
      this.topcontent.year = this.searchForm.year
      await this.getrewardinfolist(this.searchForm.year, this.searchForm.region_level, this.searchForm.region_id, this.searchForm.filter_level)
    },
    async onback() {
      console.log(this.searchForm.pregionid)
      if (this.searchForm.filter_level > 0) {
        this.searchForm.region_level = this.searchForm.region_level - 1,
          this.searchForm.filter_level = this.searchForm.filter_level - 1
        this.topcontent.regionName = this.topcontent.bregionName
        await this.getrewardinfolist(this.searchForm.year, this.searchForm.region_level, this.searchForm.pregionid, this.searchForm.filter_level)
      }
    },
    async getDetail(row) {
      console.log(row)
      this.searchForm.filter_level = this.searchForm.filter_level + 1
      this.searchForm.region_level = row.regionLevel,
        this.searchForm.region_id = row.regionId,
        this.topcontent.regionName = row.regionName
      await this.getrewardinfolist(this.searchForm.year, row.regionLevel, row.regionId, this.searchForm.filter_level)
    }
  }
}
</script>

<style scoped>
.tablecolumn {
  margin-left: 10px;
  margin-top: 5px;
}
.searchtable >>> .el-table thead.is-group th {
  background: #fff !important;
}
.searchtable >>> .is-group th {
  text-align: center;
}
.searchtable >>> .el-table .cell {
  padding: 0 !important;
}
</style>
<style scoped>
.elformitem >>> input {
  height: 33px !important;
}
.searchtable >>> .el-descriptions-item__cell {
  background: #fff !important;
  border-bottom: inherit;
  border-left: inherit;
  color: #909399;
  font-weight: 600;
  font-size: 14px;
}
.searchtable >>> .is-bordered-label {
  width: 0;
  padding: 0;
}
.tablecity >>> .el-descriptions-row td:nth-child(2) {
  /* border-left: inherit; */
  border-right: inherit;
}
.tablecity >>> .el-descriptions-row th:nth-child(3) {
  /* border-left: inherit; */
  border-right: inherit;
}
.tablecity >>> .el-descriptions-row td:nth-child(4) {
  text-align: right;
  padding: 12px 40px;
}

.tablename >>> .el-descriptions-row td:nth-child(2) {
  text-align: center;
  font-size: 17px;
}
</style>
